import React from "react";
import Retool from ".";
import { useParams } from "react-router";
import { observer } from "mobx-react-lite";
import { buildingStore } from "store/Building/BuildingStore";
import EmptyState from "components/EmptyState";
import FullScreenLayout from "layouts/MainLayout/FullScreenLayout";
import { HOTSPOT_ANALYZER_DOCS } from "utils";

const CO2HotspotAnalyzer = () => {
  const reportID = "852b7c18-dc92-11ef-b5f1-f7397b4b809b";
  const { id: BuildingId } = useParams();

  const embeddedData = {
    building_id: BuildingId,
  };

  if (!buildingStore.buildingMappingStatus.hasReport)
    return (
      <EmptyState
        type="inventory"
        loading={buildingStore.calculationsStatus.inProgress}
        containerClassName="m-6"
      />
    );

  return (
    <FullScreenLayout
      title={"CO₂ Hotspot Analyzer"}
      helpURL={HOTSPOT_ANALYZER_DOCS}
      buildingName={buildingStore.currentBuilding?.name}
    >
      <Retool url={reportID} embeddedData={embeddedData} />
    </FullScreenLayout>
  );
};

export default observer(CO2HotspotAnalyzer);
